export function isOpen(state) {
  return state.open;
}
export function entry(state) {
  return state.entry;
}